module.exports = __webpack_public_path__ + "quilt3.a0092f0d.png";